import { Dictionary } from 'src/app/core/model/dictionary';

export class CommunityServiceCategoryEdit
{
    public id = null;
    public name = '';
    public active = true;
    public serviceType: Dictionary;
}

export interface CommunityServiceCategoryList
{
    id: number;
    name: string;
    active: boolean;
    serviceType: Dictionary;
    lastModifiedBy: string;
    lastModifiedDate: Date;
}
